import registerDialog from './register-dialog';
import registeredDialogs from './registered-dialogs';

export default {
  registerDialog,
  registeredDialogs,
};
